import React from 'react';
import { isWindowExists } from '../../../helpers/windowHelper';

class ShareButtonWrapper extends React.Component {
    onClick = () => {
        if (this.props.onClick) {
            this.props.onClick();
        }

        if (isWindowExists()) {
            window.open(this.props.url);
        }
    }

    render() {
        return (
            <div className="share-button-wrapper"
                onClick={this.onClick}>
                {this.props.children}
            </div>
        )
    }
}

export default ShareButtonWrapper;